module.exports = __webpack_public_path__ + "static/img/service-05.f39ddeb7.png";